/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
import axios from 'axios';

const axiosIntercepter = axios.create({
baseURL: process.env.REACT_APP_BASE_URL,
withCredentials:true
});

// Request interceptor
axiosIntercepter.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);
// Response interceptor
axiosIntercepter.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle response errors globally
    if (error.response) {
      if (error.response.status === 401) {
        console.error('Unauthorized! Redirecting to login...');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosIntercepter;
